// Only non-sensitive UI preferences are persisted. Session material never is.
export const STORAGE_KEYS = Object.freeze({
    THEME: 'mastermind.theme',
});
